import { QueryClient } from '@tanstack/react-query';

// Server state = TanStack Query 5 (ARCH §9.3). One client per app; tests build their own with retries off.
// Query keys and options come from `@sl/core/queries` once that module exists; until then routes declare
// their keys locally and say so.

export function createQueryClient(options: { retry?: boolean | number } = {}): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: options.retry ?? 1,
        // The demo server answers from memory and the backend caches per REQ-286; refetch on focus adds
        // nothing but flicker. Refreshing is an explicit action in the shell (REQ-283).
        refetchOnWindowFocus: false,
        staleTime: 30_000,
      },
    },
  });
}
